// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__WqIzE","tab":"ProcedureTabs_tab__195Sv"};